// Undefined means this stage still uses the legacy role/recipient rules.
export function configuredRequestActor(item, supply, signatories = {}) {
  const status = String(item.status || '').trim().toLowerCase();
  const stage = String(item.requeststatus || '').trim().toLowerCase();
  const disposal = status.includes('disposal') || status === 'disposed' || item.disposal_reason || item.disposal_notes;
  if (supply) {
    if (item.request_type === 'disposal' || disposal) return signatories.sdr?.approver_id;
    if (stage === 'for checking') return signatories.ris?.checker_id;
    if (stage === 'for approval') return signatories.ris?.approver_id;
    return undefined;
  }
  if (disposal) return stage === 'for approval - afd'
    ? signatories.pdr?.approver_id : signatories.pdr?.reviewer_id;
  if (status.includes('return to inventory')) return stage === 'to receive'
    ? signatories.rti?.receiver_id : signatories.rti?.approver_id;
  if (status.includes('for issue')) {
    if (stage !== 'for approval') return undefined;
    return item.par_no || item.PAR_no || String(item.asset_type).toUpperCase() === 'PPE'
      ? signatories.par?.approver_id || signatories.ics_issuance?.approver_id
      : signatories.ics_issuance?.approver_id;
  }
  if (String(item.asset_type).toUpperCase() === 'SE' && ['for approval','for release'].includes(stage)) return signatories.ics_transfer?.approver_id;
  if (stage === 'for approval') return signatories.ptr?.approver_id;
  if (stage === 'for release') return signatories.ptr?.releaser_id;
  return undefined;
}
